import axios from "axios";
import { checkLastUpdate, setBtnSubmitStatus } from "./template/dateschedule";
/**
const URL = "http://localhost:8000/server-side/send.php";
const cancelURL = "http://localhost:8000/server-side/cancel.php?uid=";
const qrURLgenerator = "http://localhost:8000/server-side/qr.php?uid=";
/**/
/***/
const URL = "https://servizi.istitutomaxplanck.edu.it/opendays/send.php";
const cancelURL =
  "https://servizi.istitutomaxplanck.edu.it/opendays/cancel.php?uid=";
const qrURLgenerator =
  "https://servizi.istitutomaxplanck.edu.it/opendays/qr.php?uid=";
/**/
export const send = (obj) => {
  axios
    .post(URL, obj)
    .then(function (response) {
      console.log(response);
      if (!response.data.result) {
        //posti esauriti
        checkLastUpdate("0");
        setBtnSubmitStatus();
        alert(response.data.message);
      } else {
        //success print qr
        const options = {
          //weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        };
        const data = new Date(response.data.day);

        const form = document.getElementById("prenotazione");
        const resultDiv = document.getElementById("prenotazione_result");
        const html = `<h4>Dettagli della tua prenotazione</h4>
        <p class="h5 mt-3">email</p>
        <p class="h3"><strong>${response.data.data.parent_email}</strong></p>
        <p class="h5 mt-3">Giorno</p>
        <p class="h3"><strong>${data.toLocaleString(
          "it-IT",
          options
        )}</strong></p>
        <p class="h5 mt-3">Ore</p>
        <p class="h3"><strong>${response.data.time}</strong></p>
        <div class="p-1">
          <div id="prenotazione_group" class="${getGroupColorClass(
            response.data.group
          )}">
            <p class="h5 mt-3">Gruppo</p>
            <p class="h3"><strong>${response.data.group}</strong></p>
          </div>
        </div>
        <p><img src="${qrURLgenerator + response.data.hash}"></p>
        <p class="h5 mt-3">Codice</p>
        <p class="h3"><strong style="word-wrap: break-word;">${
          response.data.hash
        }</strong></p>
        <p class="my-5"><button onclick="window.print();" class="btn btn-lg btn-success">Stampa prenotazione</button></p>
        <p class="my-5"><a href="${
          cancelURL + response.data.hash
        }" class="text-danger">Cancella prenotazione</button></p>`;

        resultDiv.innerHTML = html;
        resultDiv.classList.add("active");
        form.classList.remove("active");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};

const getGroupColorClass = (group) => {
  let classe = "";
  switch (group) {
    case 1:
      classe = "bg-white";
      break;

    case 2:
      classe = "bg-green";
      break;

    case 3:
      classe = "bg-yellow";
      break;

    case 4:
      classe = "bg-pink";
      break;

    case 5:
      classe = "bg-blue";
      break;

    default:
      break;
  }
  return classe;
};
